import type { RiskPageProps } from '../../consumer/workbench';
import { riskHref } from '../../consumer/workbench';
import { ConfigurationPanel } from '../ConfigurationPanel';
import './management.css';

export function NetworkPage({ configurationPort, areaId }: RiskPageProps) {
  return (
    <section className="nm-management nm-network-page" data-nm-network-page>
      <div className="nm-management-intro">
        <h2>区域与来源管理</h2>
        <p>查看配置意图、实际接收与判断资格，再按需编辑区域和来源。</p>
        <p className="nm-scope">
          配置操作覆盖本演练实例的全部区域；当前导航范围：{areaId || '全部区域'}。
          全局配置修订用于并发冲突核对。
        </p>
        <a href={riskHref('', areaId)}>返回风险与预警总览 →</a>
      </div>
      {configurationPort ? (
        <ConfigurationPanel port={configurationPort} />
      ) : (
        <p className="nm-error" role="status">
          配置接口不可用；区域与来源状态未知。
        </p>
      )}
    </section>
  );
}
